import type { ReactNode } from "react"

import { Button, Popover, PopoverContent, PopoverTrigger } from "@coval/ui"
import { SlidersHorizontal } from "lucide-react"

export function DisplayMenu({
  children,
  summary,
  open,
  onOpenChange,
}: {
  children: ReactNode
  summary?: string
  open?: boolean
  onOpenChange?: (open: boolean) => void
}) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="secondary"
          icon
          tooltip={summary ? `Display: ${summary}` : "Display"}
          aria-label="Display options"
          active={Boolean(summary)}
        >
          <SlidersHorizontal className="size-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-80 max-w-[calc(100vw-2rem)] p-0"
      >
        <div className="space-y-4 p-4">{children}</div>
      </PopoverContent>
    </Popover>
  )
}
